export default __webpack_public_path__ + "assets/star.9ffe877a.svg";